export const tooltip = {
  variant: "text.sansMicro02Regular",
  position: "relative",
  boxShadow: "elevationMid",
  textAlign: "center",
  p: "s400",
  zIndex: 9999,
  color: "textInverse",
  bg: "backgroundInverse",
  transformOrigin: "var(--transform-origin)",
  animationDuration: "150ms",
  animationTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
  animationFillMode: "both",

  "&[data-instant]": {
    animationDuration: "0ms",
  },
};
